import { fetchUrl as s } from "@allmaps/stdlib";
import l from "./CacheableTile.js";
import { WarpedMapEvent as i, WarpedMapEventType as r } from "../shared/events.js";
class a extends l {
  /**
   * Fetch the tile and create its ImageBitMap.
   * @async
   * @returns {Promise<void>}
   */
  async fetch() {
    try {
      const e = await (await s(
        this.tileUrl,
        {
          signal: this.abortController.signal
        },
        this.fetchFn
      )).blob();
      this.data = await createImageBitmap(
        e,
        0,
        0,
        this.tile.tileZoomLevel.width,
        this.tile.tileZoomLevel.height
      ), this.dispatchEvent(
        new i(r.TILEFETCHED, this.tileUrl)
      );
    } catch (t) {
      t instanceof Error && t.name === "AbortError" || this.dispatchEvent(
        new i(r.TILEFETCHERROR, this.tileUrl)
      );
    }
    return this.data;
  }
  static createFactory() {
    return (t, e) => new a(t, e);
  }
}
class p extends a {
}
export {
  p as CachedImageBitmapTile,
  a as default
};
//# sourceMappingURL=CacheableImageBitmapTile.js.map
